// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"_3OThIe","active":"XMXatX","title":"_13INvw","text":"sO8CwF","container":"nBtrv8"};